"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagsInput = TagsInput;

var _trim2 = _interopRequireDefault(require("lodash/trim"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _fieldAlert = require("../field-alert");

var _fieldError = require("../field-error");

var _fieldsStyledComponents = require("../fields-styled-components");

var _tag = require("../../tag");

var _styledTools = require("styled-tools");

var _styles = require("react-components/styles");

var _reactForms = require("@seegno/react-forms");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["className", "disabled", "helpText", "isAcceptEvent", "label", "name", "normalizeItem"];

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * `StyledFormControlWrapper` styled component.
 */
var StyledFormControlWrapper = (0, _styledComponents["default"])(_fieldsStyledComponents.FormControlWrapper).withConfig({
  displayName: "tags-input__StyledFormControlWrapper",
  componentId: "sc-eda53-0"
})(["flex-wrap:wrap;gap:8px;padding:20px 10px 6px;", ""], _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-left: 14px;\n    padding-right: 14px;\n    padding-top: 22px;\n  "]))));
/**
 * `StyledLabel` styled component.
 */

var StyledLabel = (0, _styledComponents["default"])(_fieldsStyledComponents.Label).withConfig({
  displayName: "tags-input__StyledLabel",
  componentId: "sc-eda53-1"
})(["top:15px;", " ", ""], (0, _styledTools.ifProp)('isFloating', (0, _styledComponents.css)(["transform:translateY(-12px);"])), _styles.media.min('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    top: 18px;\n\n    ", "\n  "])), (0, _styledTools.ifProp)('isFloating', (0, _styledComponents.css)(["transform:translateY(-14px);"]))));
/**
 * `StyledFormControl` styled component.
 */

var StyledFormControl = (0, _styledComponents["default"])(_fieldsStyledComponents.FormControl).withConfig({
  displayName: "tags-input__StyledFormControl",
  componentId: "sc-eda53-2"
})(["min-height:28px;padding:0;width:auto;", ""], _styles.media.min('md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    min-height: 30px;\n    padding: 0;\n  "]))));
/**
 * Default accept event.
 */

var defaultAcceptEvent = function defaultAcceptEvent(_ref) {
  var key = _ref.key;
  return key === 'Enter';
};
/**
 * Export `TagsInput` component.
 */


function TagsInput(props) {
  var className = props.className,
      disabled = props.disabled,
      helpText = props.helpText,
      _props$isAcceptEvent = props.isAcceptEvent,
      isAcceptEvent = _props$isAcceptEvent === void 0 ? defaultAcceptEvent : _props$isAcceptEvent,
      label = props.label,
      name = props.name,
      _props$normalizeItem = props.normalizeItem,
      normalizeItem = _props$normalizeItem === void 0 ? _trim2["default"] : _props$normalizeItem,
      rest = _objectWithoutProperties(props, _excluded);

  var inputRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      wasFilled = _useState4[0],
      setWasFilled = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      selectingAutocomplete = _useState6[0],
      setSelectingAutocomplete = _useState6[1];

  var _useField = (0, _reactForms.useField)(name),
      error = _useField.error,
      meta = _useField.meta,
      _onBlur = _useField.onBlur,
      onChange = _useField.onChange,
      onFocus = _useField.onFocus,
      value = _useField.value;

  var _ref2 = meta !== null && meta !== void 0 ? meta : {},
      active = _ref2.active;

  var _useFormState = (0, _reactForms.useFormState)(),
      alreadySubmitted = _useFormState.alreadySubmitted,
      isSubmitting = _useFormState.isSubmitting;

  var hasError = !!error && alreadySubmitted;
  var isDisabled = disabled || isSubmitting;

  function appendValue(event) {
    var newValue = normalizeItem(event.target.value);

    if (!(0, _isEmpty2["default"])(newValue)) {
      (0, _tag.addTag)(value, newValue, function (newTags) {
        onChange(newTags);
        setInputValue('');
      });
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormGroup, {
    className: className,
    disabled: isDisabled,
    hasAlert: hasError || !!helpText,
    onClick: function onClick() {
      return inputRef.current && inputRef.current.focus();
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledFormControlWrapper, {
    disabled: isDisabled,
    hasError: hasError,
    hasFocus: active
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    disabled: isDisabled,
    htmlFor: name,
    isFloating: Boolean(value) || active
  }, label), (0, _map2["default"])(value, function (tag, index) {
    return /*#__PURE__*/_react["default"].createElement(_tag.Tag, {
      disabled: isDisabled,
      key: tag,
      name: "".concat(name, "[").concat(index, "]"),
      onRemove: function onRemove() {
        return onChange((0, _tag.removeTag)(value, tag));
      },
      value: tag
    });
  }), /*#__PURE__*/_react["default"].createElement(StyledFormControl, _extends({}, rest, {
    disabled: isDisabled,
    id: name,
    name: name,
    onBlur: function onBlur(event) {
      appendValue(event);

      _onBlur(event);
    },
    onChange: function onChange(event) {
      var newValue = event.target.value;

      if ((0, _isEmpty2["default"])(newValue) && !(0, _isEmpty2["default"])(inputValue)) {
        setWasFilled(true);
      }

      setInputValue(newValue);
    },
    onFocus: onFocus,
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        // Prevent form submit unless the user is pressing ctrl or meta.
        if (event.ctrlKey || event.metaKey) {
          return;
        }

        event.preventDefault();
      }
    },
    onKeyUp: function onKeyUp(event) {
      if (event.key === 'Enter' && selectingAutocomplete) {
        return setSelectingAutocomplete(false);
      }

      if (isAcceptEvent(event)) {
        return appendValue(event);
      }

      switch (event.key) {
        case 'Backspace':
          {
            // Don't remove last tag on backspace event that cleared the input.
            if (wasFilled) {
              setWasFilled(false);
            } else if ((0, _isEmpty2["default"])(inputValue)) {
              onChange((0, _tag.removeLastTag)(value));
            }

            return;
          }

        case 'ArrowDown':
        case 'ArrowUp':
        case 'Down':
        case 'Up':
          return setSelectingAutocomplete(true);

        default:
          {
            setWasFilled(false);
            setSelectingAutocomplete(false);
          }
      }
    },
    ref: inputRef,
    type: 'text',
    value: inputValue
  }))), helpText && /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: !hasError
  }, helpText), /*#__PURE__*/_react["default"].createElement(_fieldError.FieldError, {
    error: error,
    isOpen: hasError,
    name: name
  }));
}